import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { NOT_HIRED_REASON_OTHER } from '@app/types/order';

export interface OrderCancelInput {
  cancelReason: string;
  otherReason: string;
  /** 非採用の旨のメールを送るかどうか。NOTE:既定は送らない */
  sendNotHiredMail: boolean;
}

export const OrderCancelFormDefaultValues: OrderCancelInput = {
  cancelReason: '',
  otherReason: '',
  sendNotHiredMail: false,
};

const OrderCancelFormSchema = z
  .object({
    cancelReason: z
      .string()
      .min(1, { message: '不採用理由を選択してください' }),
    otherReason: z.string(),
    sendNotHiredMail: z.boolean(),
  })
  // NOTE:「(ドクター都合)その他」等は都合が特定できているため補足コメントは求めない
  .refine(
    (data) =>
      !(data.cancelReason === NOT_HIRED_REASON_OTHER && !data.otherReason),
    {
      message: '補足コメントを入力してください',
      path: ['otherReason'],
    }
  );

export const OrderCancelForm = {
  defaultValues: OrderCancelFormDefaultValues,
  resolver: zodResolver(OrderCancelFormSchema),
  schema: OrderCancelFormSchema,
} as const;
